import { useTranslation } from "react-i18next";

export function PageLoading() {
  const { t } = useTranslation();
  return (
    <div role="status" className="flex items-center justify-center gap-3 py-16 text-fg-muted">
      <span
        aria-hidden="true"
        className="h-5 w-5 animate-spin rounded-full border-2 border-secondary-muted border-t-secondary"
      />
      <span>{t("common.loading")}</span>
    </div>
  );
}
